/**
 * Copyright 2026 Spicy Friends Ltd.
 */
import { useMatches } from '@tanstack/react-router'

export function useFooterLayoutStaticData(): {
  hideFooter: boolean
} {
  const matches = useMatches()
  const hideFooter = matches.some((match) => match.staticData?.hideFooter)
  return { hideFooter }
}
